import type { Campaign } from "../../../shared/types";
export type CampaignFeedFilter = "all" | "attention" | "complete" | "archived";
export function campaignWorkCounts(raw: unknown): { review: number; blocked: number } | null {
  if (typeof raw === "string") { try { raw = JSON.parse(raw); } catch { return null; } }
  if (!raw || typeof raw !== "object" || Array.isArray(raw)) return null;
  const counts = raw as Record<string, unknown>;
  const value = (key: string) => counts[key] === undefined ? 0 : Number(counts[key]);
  const review = value("in_review"), blocked = value("blocked");
  return Number.isInteger(review) && review >= 0 && Number.isInteger(blocked) && blocked >= 0 ? { review, blocked } : null;
}
export function campaignNeedsAttention(campaign: Campaign & { brief_counts?: unknown }): boolean {
  const counts = campaignWorkCounts(campaign.brief_counts);
  return !!counts && counts.review + counts.blocked > 0;
}
export function campaignMatchesFilter(campaign: Campaign & { brief_counts?: unknown }, filter: CampaignFeedFilter): boolean {
  if (filter === "archived") return campaign.status === "archived";
  if (campaign.status === "archived") return false;
  if (filter === "complete") return campaign.status === "completed";
  if (filter === "attention") return campaignNeedsAttention(campaign);
  return true;
}
